/**
 * Converte uma string para formato slug (URL-friendly).
 *
 * - Acentos/cedilha removidos:     'Ação'         → 'acao'
 * - Ponto entre letras/fim:        'V.W.' / 'S.10' → 'vw' / 's10'
 * - Ponto entre dígitos preservado: '1.0 MPFI'     → '1.0-mpfi'
 * - Caracteres especiais removidos: 'Tracker (Novo)' → 'tracker-novo'
 * - Espaços viram hífen:           'Civic Sedan'   → 'civic-sedan'
 * - Hífen existente mantido:       'C-HR'          → 'c-hr'
 * - Tudo minúsculo:                'VOLKSWAGEN'    → 'volkswagen'
 * - String vazia retorna null.
 */

export function formatToSlug(value: string) {
    if (value) {
        // Remove acentos e caracteres especiais
        value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

        // Remove pontos exceto entre dígitos (ex: 1.0, 1.3)
        value = value.replace(/\.(?!\d)|(?<!\d)\./g, '');

        // Remove todos os caracteres que não são letras, números, hífens, pontos ou espaços
        value = value.replace(/[^\w\s.-]/g, '');

        // Substitui espaços por hífens
        value = value.trim().replace(/\s+/g, '-');

        return value.toLowerCase();
    }
    return null;
}
